<div class="position-absolute bottom-7 start-20">
  <app-scale-control> </app-scale-control>
</div>

<app-datasource-dropdown />

<div
  class="position-absolute bottom-7 end-5 z-3 shadow-sm rounded-2 bg-dark cursor-pointer border border-darkgray d-flex gap-2 align-items-center text-deactivated"
>
  <div class="d-flex">
    <div
      class="d-flex flex-column justify-content-center p-2 text-deactivated"
      placement="top"
      ngbTooltip="Show history mode"
      tooltipClass="custom-tooltip"
      [openDelay]="1000"
      data-cy="history-mode-btn"
    >
      <span
        class="rb-ic rb-ic-history fs-2xl ho-layer-text"
        (click)="toggleHistory()"
        [class.sel-menu-item]="isHistoryVisible"
      ></span>
      <!-- *hasPermissionAny="[Permissions.RCS_Historic_All_Read]" -->
    </div>
  </div>
</div>
<app-map-navigation>
  <span class="border-bottom border-darkgray"> </span>
  <span
    class="rb-ic rb-ic-alert-info fs-2xl hover-effect p-2"
    [class.sel-menu-item]="isLegendVisible"
    (click)="toggleLegend()"
    placement="start"
    ngbTooltip="Show legend"
    tooltipClass="custom-tooltip"
    [openDelay]="1000"
  >
  </span>
  <span class="border-bottom border-darkgray"> </span>
  <span
    class="rb-ic rb-ic-heatmap fs-2xl hover-effect p-2"
    [class.sel-menu-item]="drawService.isDrawMode"
    [class.rounded-bottom-2]="drawService.isDrawMode"
    (click)="drawService.toggleDrawMode()"
    placement="start"
    ngbTooltip="Draw blacklist area"
    tooltipClass="custom-tooltip"
    [openDelay]="1000"
  >
  </span>
</app-map-navigation>
<app-vzo-data-layer-config [providerInfo$]="this.ProviderInfo$"></app-vzo-data-layer-config>
@if (isLegendVisible) {
  <app-internal-legend></app-internal-legend>
}
<app-observations-details></app-observations-details>
<app-clustered-signs-details></app-clustered-signs-details>
<app-non-detections-details></app-non-detections-details>
<app-internal-rollouts-map-tile-segment-details></app-internal-rollouts-map-tile-segment-details>
<app-internal-rollouts-map-tile-matched-signs-details></app-internal-rollouts-map-tile-matched-signs-details>
<app-rollouts-map-tile-filtered-matched-signs-details></app-rollouts-map-tile-filtered-matched-signs-details>
<app-road-coverage-segment-details></app-road-coverage-segment-details>
<app-speed-profile-segment-details></app-speed-profile-segment-details>
<app-matched-signs-details></app-matched-signs-details>
<app-rollout-date></app-rollout-date>
<app-construction-sites-details></app-construction-sites-details>
<app-sign-simulation-dialog
  [providerInfo$]="ProviderInfo$"
  *hasPermissionAny="[Permissions.VZO_Observations_Write]"
></app-sign-simulation-dialog>
<app-blacklist-area-dialog></app-blacklist-area-dialog>
@if (isHistoryVisible) {
  <app-internal-history-control
    (historyClosed)="handleHistoryClosed()"
  ></app-internal-history-control>
}
